import { render, staticRenderFns } from "./BargainCard.vue?vue&type=template&id=445c6e94&scoped=true&"
import script from "./BargainCard.vue?vue&type=script&lang=js&"
export * from "./BargainCard.vue?vue&type=script&lang=js&"
import style0 from "./BargainCard.vue?vue&type=style&index=0&id=445c6e94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c6e94",
  null
  
)

export default component.exports